import React, { useEffect, useState } from 'react';
import ReferAndEarn from './ReferAndEarn';
import { ReferWrapper } from './styles';
import {
  getContentSchemaFromContentFul,
  getInstapointHistory
} from '../../redux/actions/common/common-action';
import isEmpty from 'lodash/isEmpty';
import { getReferralCMSSpecificToCountry } from '../../utils/cmsData/filterCntentCountrySpecific';
import { CONTENTFUL_SCHEMA_KEYS, IP_HISTORY_PAGE_SIZE, REFERRAL_BASE_URL } from '../../utils/constants';
import { useSelector, useDispatch } from 'react-redux';
import { History, ReferEarnProps } from './interface';
import { activateLoader, disableLoader } from '../../redux/actions/ui-trigger/ui-trigger-action';
import { getInstaPoints } from '../../redux/actions/instapoints/instapoints-action';
import { selectIPBalance, selectUserSession } from '../../redux/selectors';
import { AppDispatch } from '../../store.type';

const ReferEarn: React.FC<ReferEarnProps> = (props): React.ReactElement => {
  const [cmsReferalSchema, setCmsReferalSchema] = useState<Record<string, unknown>>({});
  const [historyData, setHistoryData] = useState<History[]>([]);
  const [totalInstapoints, setTotalInstapoints] = useState(0);
  const [instapointsEarnedCurrentMonth, setInstapointsEarnedCurrentMonth] = useState(0);
  const [instapointsExpiringCurrentMonth, setInstapointsExpiringCurrentMonth] = useState(0);
  const [ipBalanceTransactions, setIpBalanceTransactions] = useState(0);
  const [ipBalanceReferral, setIpBalanceReferral] = useState(0);
  const userSession = useSelector(selectUserSession);
  const ipBalance = useSelector(selectIPBalance);
  const isAmazeUser = userSession?.is_amaze_customer;
  const isRemittanceUser = userSession?.is_remittance_transaction_initiated;
  const dispatch = useDispatch<AppDispatch>();

  const fetchData = async () => {
    dispatch(activateLoader());
    const contentFulSchema = await getContentSchemaFromContentFul(
      CONTENTFUL_SCHEMA_KEYS['REFER_N_EARN']['CONTENT_TYPE'],
      CONTENTFUL_SCHEMA_KEYS['REFER_N_EARN']['TITLE']
    );
    if (!isEmpty(contentFulSchema)) {
      const countrySpecific = getReferralCMSSpecificToCountry(
        contentFulSchema,
        userSession?.country_code,
        isAmazeUser,
        isRemittanceUser
      );
      setCmsReferalSchema(countrySpecific);
    }
    dispatch(disableLoader());
  };

  const getReferHistory = async () => {
    dispatch(activateLoader());
    try {
      const referralResponse = await getInstapointHistory({ referral_instapoint: true });
      const updatedAll = referralResponse?.data?.data?.referral_activity;
      setHistoryData(updatedAll);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
    dispatch(disableLoader());
  };

  const getInstapointsBalanceSummary = async () => {
    try {
      const response = await getInstapointHistory({ page: 1, size: IP_HISTORY_PAGE_SIZE });
      const { total_instapoints, instapoint_summary } = response?.data?.data || {};
      setTotalInstapoints(total_instapoints || 0);
      setInstapointsEarnedCurrentMonth(instapoint_summary?.instapoints_earned_in_current_month || 0);
      setInstapointsExpiringCurrentMonth(
        instapoint_summary?.instapoints_expiring_in_current_month || 0
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  const getIpBalanceBreakdown = async () => {
    const ipBalanceResponse: any = await dispatch(getInstaPoints());
    setIpBalanceTransactions(ipBalanceResponse?.transaction_instapoints || 0);
    setIpBalanceReferral(ipBalanceResponse?.referral_instapoints || 0);
  };

  useEffect(() => {
    fetchData();
    getReferHistory();
    getInstapointsBalanceSummary();
    getIpBalanceBreakdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const url = `${REFERRAL_BASE_URL}${userSession?.referral_code}`;

  return (
    <ReferWrapper>
      <ReferAndEarn
        countryCode={userSession?.country_code}
        referandEarnSchema={cmsReferalSchema}
        initialReferralInstapoint={ipBalance?.initial_referral_instapoint}
        redemptionValue={ipBalance?.redemption_value}
        transactionReferralInstapoint={ipBalance?.transaction_referral_instapoint}
        totalInstapoints={totalInstapoints}
        instapointsEarnedCurrentMonth={instapointsEarnedCurrentMonth}
        instapointsExpiringCurrentMonth={instapointsExpiringCurrentMonth}
        ipBalanceTransactions={ipBalanceTransactions}
        ipBalanceReferral={ipBalanceReferral}
        url={url}
        historyData={historyData}
      ></ReferAndEarn>
    </ReferWrapper>
  );
};

export default ReferEarn;
